
$(document).ready(function () {
   $('.categories-slider').owlCarousel({
      loop: true,
      nav: true,
      margin: 10,
      responsiveClass: true,
      responsive: {
         0: {
            items: 2
         },
         450: {
            items: 3
         },
         600: {
            items: 4
         },
         800: {
            items: 5
         },
         1000: {
            items: 6
         },
         1200: {
            items: 7
         }
      }
   });

   $('.bestproduct-slider').owlCarousel({
      loop: true,
      nav: true,
      margin: 5,
      responsiveClass: true,
      responsive: {
         0: {
            items: 1
         },
         500: {
            items: 2
         },
         650: {
            items: 3
         },
         1000: {
            items: 4
         },
         1200: {
            items: 5
         }
      }
   });

   $('.all-categories-slider').owlCarousel({
      loop: true,
      nav: true,
      margin: 10,
      responsiveClass: true,
      responsive: {
         0: {
            items: 1
         },
         600: {
            items: 1
         },
         1000: {
            items: 3
         },
         1200: {
            items: 4
         }
      }
   });

   // modal pupup
   $('.dropdown-menu').click(function (e) {
      e.stopPropagation();
      if ($(e.target).is('[data-toggle=modal]')) {
         $($(e.target).data('target')).modal()
      }
   });

   $(window).scroll(function () {
      var sticky = $('.brand-link'),
         scroll = $(window).scrollTop();
      if (scroll >= 200) sticky.addClass('fixed');
      else sticky.removeClass('fixed');
   });

   //scrolltop
   $(".takeme-up").click(function () {
      $("html").animate({ scrollTop: 0 }, "slow");
   });

   $(".click-formenu").click(function () {
      $("body").toggleClass("menu-open");
   });

   $(document).click(function (e) {
      if (!e.target.matches('.categories-nav.dropdown, .categories-nav.dropdown *')) {
         $("body").removeClass("menu-open");
      }
   });


   $(".overlay").click(function () {
      $("body").removeClass("menu-open");
   });

   //dropdwon
   /////// Prevent closing from click inside dropdown
   document.querySelectorAll('.dropdown-menu').forEach(function (element) {
      element.addEventListener('click', function (e) {
         e.stopPropagation();
      });
   });

   // make it as accordion for smaller screens
   if (window.innerWidth > 300) {
      document.querySelectorAll('.navbar .nav-item').forEach(function (everyitem) {
         everyitem.addEventListener('mouseover', function (e) {
            /* let el_link = this.querySelector('a[data-bs-toggle]');
            if(el_link != null){
               let nextEl = el_link.nextElementSibling;
               el_link.classList.add('show');
               nextEl.classList.add('show');
            } */
         });
         everyitem.addEventListener('mouseleave', function (e) {
            /* let el_link = this.querySelector('a[data-bs-toggle]');
            if(el_link != null){
               let nextEl = el_link.nextElementSibling;
               el_link.classList.remove('show');
               nextEl.classList.remove('show');
            } */
         });
      });
   }
   // end if innerWidth

});

// for mobile
$(document).ready(function () {
   function checkWidth() {
      var windowSize = $(window).width();
      if (windowSize <= 767) {
         $(".brand-link a ").click(function (e) {
            e.preventDefault();
            id = $(this).attr("href");
            $('html, body').animate({
               scrollTop: $(id).offset().top - 200
            }, 2000);
         });
      } else if (windowSize = 768 && windowSize <= 991) {
         $(".brand-link a ").click(function (e) {
            e.preventDefault();
            id = $(this).attr("href");
            $('html, body').animate({
               scrollTop: $(id).offset().top - 200
            }, 2000);
         });
      } else if (windowSize = 992 && windowSize <= 1024) {
         $(".brand-link a ").click(function (e) {
            e.preventDefault();
            id = $(this).attr("href");
            $('html, body').animate({
               scrollTop: $(id).offset().top - 230
            }, 2000);
         });
      } else if (windowSize >= 1100) {
         $(".brand-link a ").click(function (e) {
            e.preventDefault();
            id = $(this).attr("href");
            $('html, body').animate({
               scrollTop: $(id).offset().top - 180
            }, 2000);
         });
      }
   }

   // Execute on load
   checkWidth();
   // Bind event listener
   $(window).resize(checkWidth);
});

$('.login-create-account').on("click", function (e) {
   e.preventDefault();
   $('#login-modal').modal('hide');
   $('#signup-modal').modal('show');
});

$('.create-account-login').on("click", function (e) {
   e.preventDefault();
   $('#signup-modal').modal('hide');
   $('#login-modal').modal('show');
});

$('.nav-sign-in-modal').on("click", function (e) {
   e.preventDefault();
   $('#login-modal').modal('show');
});

$('.nav-create-account-modal').on("click", function (e) {
   e.preventDefault();
   $('#signup-modal').modal('show');
});

$(function () {
   $('[data-toggle="tooltip"]').tooltip()
})

$('.shop-now-btn').on('click', function (e) {
   e.preventDefault();
   //$(this).html('Processing...');
   var product_id = $(this).attr('data-product-id')
   var qty = $(this).attr('data-product-min')
   var product_mpn = this.getAttribute('data-product-mpn')
   var product_name = this.getAttribute('data-product-name')
   gtag('event', 'add_to_cart', {
      "items": [{
         "id": product_mpn,
         "name": product_name,
         "list_name": "Home Page",
         "quantity": qty
      }]
   });
   /* fbq('track', 'AddToCart',{
      content_name: product_name,
      content_ids: product_mpn,
      content_type: 'product'
   }); */
   cart.add(product_id, qty)
});

$('#button-cart').on('click', function () {
   var product_id = $('.add-to-cart .qty_product_id').val();
   var product_mpn = $('.add-to-cart .qty_product_mpn').val();
   var product_name = $('.add-to-cart .qty_product_name').val();
   var qty = $('.add-to-cart input[type=\'number\']').val();
   gtag('event', 'add_to_cart', {
      "items": [{
         "id": product_mpn,
         "name": product_name,
         "list_name": "Product Detail Page",
         "quantity": qty
      }]
   });
   /* fbq('track', 'AddToCart',{
      content_name: product_name,
      content_ids: product_mpn,
      content_type: 'product'
   }); */
   cart.add(product_id, qty);
});

// $('.notify-now-btn').on('click', function (e) {
//    e.preventDefault();
//    var product_id = this.getAttribute('data-product-id')
//    //$('#notify-modal .notifyform #notify_product_id').val(product_id);
//    //$('#notify-modal .notifyform').show();
//    //$('#notify-modal .success').hide();
//    //$('#notify-modal').modal('show');

//    $('#notify-modal .content .form #notify_product_id').val(product_id);
//    $('#notify-modal .content .form').show();
//    $('#notify-modal .content .success').hide();
//    $('#notify-modal').iziModal('open')
// });

// $('#button-notify').on('click', function (e) {
//    e.preventDefault()
//    var product_id = this.getAttribute('data-product-id')
//    $('#notify-modal .notifyform #notify_product_id').val(product_id);
//    $('#notify-modal .notifyform').show();
//    $('#notify-modal .success').hide();
//    $('#notify-modal').modal('show');
// });

$(".more-detail a ").click(function (e) {
   e.preventDefault();
   id = $(this).attr("href");
   $('html, body').animate({
      scrollTop: $(id).offset().top - 180
   }, 500);
});

// $('.newsletter-section .footer-submit').on('click', function (e) {
//    e.preventDefault()
//    email_val = $('.newsletter-section .footer-email').val();
//    if (email_val.length >= 3) {
//       $.ajax({
//          type: 'POST',
//          url: '/constant_contact_add_update.php',
//          data: {
//             type: 'add_mail_subscriber_popup',
//             email: email_val
//          },
//          success: function (response) {
//             //console.log(response);
//             html = '<h3>Thank You For Subscribing!</h3>';
//             if (html) {
//                //console.log(html);
//                $('.newsletter-section .newsletter-text').html(html);
//             }
//          }
//       });
//    } else {
//       $('.newsletter-section .footer-email').addClass('invalid');
//    }
// });

$(".newsletter-block .footer-submit").on("click", function (e) {
   e.preventDefault();
   email_val = $(".newsletter-block .footer-email").val();
   if (email_val == '') {
      $(".newsletter-block .newsletter_promo_text").html("<p style='color:red;'><i class='fa fa-info-circle'></i> Please enter your email address</p>");
      setTimeout(function () {
         $(".newsletter-block .newsletter_promo_text").html('<p><i class="fa fa-lock"></i> We respect your privacy. No spam. Unsubscribe anytime</p>');
      }, 5000);
      return false;
   }
   name_val = $(".newsletter-block .footer-name").val();
   if (email_val.length >= 3) {
      $.ajax({
         type: 'POST',
         url: '/constant_contact_add_update.php',
         data: {
            type: 'add_mail_subscriber_popup',
            email: email_val
         },
         success: function (response) {
            //console.log(response);
            html = '<h3>Thank You For Subscribing!</h3>';
            if (html) {
               //console.log(html);
               $('.newsletter-section .newsletter-text').html(html);
            }
         }
      });
   } else {
      $(".newsletter-block .footer-email").addClass("is-invalid");
   }
});

jQuery(function ($) {
   var searchTimer;                //timer identifier
   var searchInt = 200;  //time in ms, 5 second for example
   var search_val = '';
   var searchInput = $('#sitesearch');

   $(searchInput).on('keyup', function () {
      search_val = $(this).val();
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
         if (search_val.length > 2) {
            $.ajax({
               url: 'index.php?route=common/essearch/search&search=' + search_val,
               dataType: 'json',
               beforeSend: function () {
                  $('.e-search-outer').removeClass('active')
               },
               complete: function () { },
               success: function (response) {
                  if (response.success == true) {
                     html_s = '<div class="row m-0"><div class="col-md-12 p-0"><button class="close" id="close-search-modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>';
                     html_e = '</div>';
                     prod_html = '';
                     cat_html = '';
                     final_html = '';
                     if (response.data) {
                        if (response.data.categories) {
                           cat_html += '<ul class="list-group list-group-flush list-item-link ">';
                           $.each(response.data.categories, function (index, value) {
                              cat_html += '<li class="list-group-item"> <a href="' + value.category_url + '"> ' + value.name + ' </a></li>';
                           });
                           cat_html += '</ul>';
                        }
                        if (response.data.products) {
                           $.each(response.data.products, function (index, value) {
                              prod_html += '<div class="media pos-rel mb-2 pb-1 border-bottom">';
                              prod_html += '<a href="' + value.href + '"><img src="' + value.thumb + '" class="mr-3 cart-product" alt="' + value.name + '"></a>';
                              prod_html += '<div class="media-body">';
                              prod_html += '<h6 class="mt-0"><a href="' + value.href + '">' + value.name + '</a></h6>';
                              prod_html += '<div class="row m-0 mt-1 j-inbetween">';
                              prod_html += value.price_html;
                              prod_html += value.button_html;
                              prod_html += '</div>';
                              prod_html += '</div>';
                              prod_html += '</div>';
                           });
                        }
                     }
                     if (cat_html && prod_html) {
                        final_html += html_s + '<div class="col-md-4 border-right p-0">' + cat_html + '</div><div class="col-md-8 pt-3">' + prod_html + '</div>' + html_e;
                        $('.e-search-outer').html(final_html);
                        $('.e-search-outer .shop-now-btn').on('click', function (e) {
                           e.preventDefault();
                           //$(this).html('Processing...');
                           var product_id = $(this).attr('data-product-id')
                           var qty = $(this).attr('data-product-min')
                           var product_mpn = $(this).attr('data-product-mpn')
                           var product_name = $(this).attr('data-product-name')
                           gtag('event', 'add_to_cart', {
                              "items": [{
                                 "id": product_mpn,
                                 "name": product_name,
                                 "list_name": "Home Page",
                                 "quantity": qty
                              }]
                           });
                           /* fbq('track', 'AddToCart',{
                              content_name: product_name,
                              content_ids: product_mpn,
                              content_type: 'product'
                           }); */
                           cart.add(product_id, qty)
                        });
                        $('.e-search-outer .notify-now-btn').on('click', function (e) {
                           e.preventDefault();
                           var product_id = this.getAttribute('data-product-id')
                           $('#notify-modal .notifyform #notify_product_id').val(product_id);
                           $('#notify-modal .notifyform').show();
                           $('#notify-modal .success').hide();
                           $('#notify-modal').modal('show')
                        });
                        $('#close-search-modal').on('click', function (e) {
                           e.preventDefault();
                           $('.e-search-outer').removeClass('active');
                           $('.e-search-outer').html('');
                           $('html, body').removeClass('mobile-fixed')
                        });
                        $('.e-search-outer').addClass('active');
                        $('html, body').addClass('mobile-fixed');
                     } else if (cat_html) {
                        final_html += html_s + '<div class="col-md-12 p-0">' + cat_html + '</div>' + html_e;
                        $('.e-search-outer').html(final_html);
                        $('#close-search-modal').on('click', function (e) {
                           e.preventDefault();
                           $('.e-search-outer').removeClass('active');
                           $('.e-search-outer').html('');
                           $('html, body').removeClass('mobile-fixed')
                        });
                        $('.e-search-outer').addClass('active');
                        $('html, body').addClass('mobile-fixed');
                     } else if (prod_html) {
                        final_html += html_s + '<div class="col-md-12 pt-3">' + prod_html + '</div>' + html_e;
                        $('.e-search-outer').html(final_html);
                        $('.e-search-outer .shop-now-btn').on('click', function (e) {
                           e.preventDefault();
                           //$(this).html('Processing...');
                           var product_id = $(this).attr('data-product-id')
                           var qty = $(this).attr('data-product-min')
                           var product_mpn = $(this).attr('data-product-mpn')
                           var product_name = $(this).attr('data-product-name')
                           gtag('event', 'add_to_cart', {
                              "items": [{
                                 "id": product_mpn,
                                 "name": product_name,
                                 "list_name": "Home Page",
                                 "quantity": qty
                              }]
                           });
                           /* fbq('track', 'AddToCart',{
                              content_name: product_name,
                              content_ids: product_mpn,
                              content_type: 'product'
                           }); */
                           cart.add(product_id, qty)
                        });
                        $('.e-search-outer .notify-now-btn').on('click', function (e) {
                           e.preventDefault();
                           var product_id = this.getAttribute('data-product-id')
                           $('#notify-modal .form #notify_product_id').val(product_id);
                           $('#notify-modal .form').show();
                           $('#notify-modal .success').hide();
                           $('#notify-modal').iziModal('open');
                        });
                        $('#close-search-modal').on('click', function (e) {
                           e.preventDefault();
                           $('.e-search-outer').removeClass('active');
                           $('.e-search-outer').html('');
                           $('html, body').removeClass('mobile-fixed')
                        });
                        $('.e-search-outer').addClass('active');
                        $('html, body').addClass('mobile-fixed');
                     }
                  }
               }
            });
         } else {
            $('.e-search-outer').removeClass('active');
            $('.e-search-outer').html('');
            $('html, body').removeClass('mobile-fixed')
         }
      }, searchInt);
   });

   $(document).mouseup(function (e) {
      var container = $('.search-box');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
         $('.e-search-outer').removeClass('active');
         $('.e-search-outer').html('');
         $('html, body').removeClass('mobile-fixed')
      }
   });
});
